import { Component } from '@angular/core';

@Component({
  selector: 'app-summarizer-info',
  imports: [],
  templateUrl: './summarizer-info.html',
  styleUrl: './summarizer-info.scss'
})
export class SummarizerInfo {

}
